import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/ClearOutlined";
import EditIcon from "@mui/icons-material/Create";
import {
  FormControlLabel,
  FormGroup,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Checkbox,
  Button,
  Grid,
} from "@mui/material";
import Fade from "@mui/material/Fade";
import React from "react";

import HelperText from "../../../../components/feedback/helper-text";
import { language } from "../../../../language";
import { getUnitPropertie } from "../../../smart/camunda/forms/functions";
import { getPropertieObjectById, findObjectDefaultValue } from "../helper";

const StyledItem = (props) => {
  const obj = props.item;

  const [input, setinput] = React.useState({
    text: obj && obj.label,
    id: obj && obj.id,
  });
  const [edit, setedit] = React.useState(false);

  const isEditing = () => {
    setedit(!edit);
  };

  const handleChange = (event) => {
    const { name, value } = event.target;

    setinput((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (event, input) => {
    event.preventDefault();
    props.edit(input, obj.uuid);
    isEditing();
  };

  const styled_actions = {
    position: "absolute",
    top: "8px",
    right: "16px",
    fontSize: "18px",
  };

  const styled_container = {
    marginBottom: "5px",
    padding: "10px",
    minHeight: "50px",
    borderRadius: "4px",
    border: "1px solid #c1c1c1",
    position: "relative",
  };

  return (
    <div style={styled_container}>
      <div>
        {edit ? (
          <div>
            <Fade in={edit}>
              <Grid container direction="row" alignItems="center" spacing={0}>
                <TextField
                  type="text"
                  id="standard-basic"
                  name="id"
                  onChange={(event) => handleChange(event)}
                  value={input.id}
                  label={`${language.id}: `}
                  size="small"
                  style={{ width: "30%" }}
                />
                <TextField
                  type="text"
                  id="standard-basic"
                  name="text"
                  onChange={(event) => handleChange(event)}
                  value={input.text}
                  label={language.propertieLabel}
                  size="small"
                  style={{ width: "30%" }}
                />

                <Button
                  variant="contained"
                  color="secondary"
                  onClick={(event) => handleSubmit(event, input)}
                >
                  {language.save}
                </Button>
                <Button
                  variant="contained"
                  color="error"
                  onClick={isEditing}
                >
                  {language.cancel}
                </Button>
              </Grid>
            </Fade>
          </div>
        ) : (
          <div>
            <Grid container direction="row" alignItems="center" spacing={0}>
              <Grid item xs={8}>
                <div>
                  <strong>{language.id}: </strong>
                  {obj && obj.id}
                </div>
                <div>
                  <strong>{language.propertieLabel}: </strong>
                  {obj && obj.label}
                </div>
              </Grid>
              <Grid item xs={4}>
                <div style={styled_actions}>
                  <EditIcon
                    onClick={isEditing}
                    style={{ cursor: "pointer", marginRight: "10px" }}
                  />
                  <DeleteIcon
                    onClick={() => props.delete(obj.uuid)}
                    style={{ cursor: "pointer" }}
                  />
                </div>
              </Grid>
            </Grid>
          </div>
        )}
      </div>
    </div>
  );
};

export default class LinkedListModal {
  static DisplayTab(props) {
    const {
      onChange,
      onCheckChange,
      onPropertieChange,
      state,
      error,
    } = props;
    const toolTip = getUnitPropertie(state, "toolTip");
    const required = getUnitPropertie(state, "required");
    const readOnly = getUnitPropertie(state, "readOnly");
    const showField = getUnitPropertie(state, "showField");
    const hidden = getUnitPropertie(state, "hidden");
    const fullWidth = getUnitPropertie(state, "fullWidth");
    const label = getUnitPropertie(state, "label");
    const isRequired = getUnitPropertie(state, "isRequired");

    return (
      <Grid container spacing={2}>
        <Grid item size={12}>
          <TextField
            onChange={(event) => onChange(event)}
            name="id"
            variant="outlined"
            id="id"
            label="Id"
            value={state.id || ""}
            fullWidth
            helperText={language.toolTipId}
          />
        </Grid>
        <Grid item size={12}>
          <TextField
            onChange={onPropertieChange}
            name="label"
            variant="outlined"
            id="label"
            label={language.propertieLabel}
            value={label || ""}
            fullWidth
            helperText={language.toolTipLabel}
          />
        </Grid>

        <Grid item size={12}>
          <TextField
            onChange={(event) => onChange(event)}
            name="description"
            variant="outlined"
            id="descricao"
            label={language.propertieDescription}
            value={state.description || ""}
            fullWidth
            helperText={language.toolTipDescription}
          />
        </Grid>

        <Grid item size={12}>
          <TextField
            onChange={(event) => onPropertieChange(event)}
            name="toolTip"
            variant="outlined"
            id="standard-basic"
            label={language.propertieToolTip}
            value={toolTip || ""}
            multiline
            rows="4"
            fullWidth
            helperText={language.toolTipToolTip}
          />
        </Grid>

        <Grid item size={12}>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  name="isRequired"
                  onChange={(event) => onCheckChange(event)}
                  value={isRequired}
                  checked={isRequired || false}
                />
              }
              label={language.propertieRequired}
            />
          </FormGroup>
        </Grid>
        <Grid item size={12}>
          <TextField
            onChange={(event) => onPropertieChange(event)}
            name="required"
            variant="outlined"
            id="standard-basic"
            label={language.propertieRequired}
            value={required || ""}
            disabled={!isRequired}
            error={!!getPropertieObjectById(error, "required")}
            fullWidth
          />
          {error && getPropertieObjectById(error, "required") && (
            <HelperText>{language.requirederror}</HelperText>
          )}
        </Grid>

        <Grid item size={12}>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  name="readOnly"
                  onChange={(event) => onCheckChange(event)}
                  value={readOnly}
                  checked={readOnly || false}
                />
              }
              label={language.propertieReadonly}
            />
            <FormControlLabel
              control={
                <Checkbox
                  name="showField"
                  onChange={(event) => onCheckChange(event)}
                  value={showField}
                  checked={showField || false}
                />
              }
              label={language.propertieShowfield}
            />
            <FormControlLabel
              control={
                <Checkbox
                  name="hidden"
                  onChange={(event) => onCheckChange(event)}
                  value={hidden}
                  checked={hidden || false}
                />
              }
              label={language.propertieHidden}
            />
            <FormControlLabel
              control={
                <Checkbox
                  name="fullWidth"
                  onChange={(event) => onCheckChange(event)}
                  value={fullWidth}
                  checked={fullWidth || false}
                />
              }
              label={language.propertieFullWidth}
            />
          </FormGroup>
        </Grid>
      </Grid>
    );
  }

  static ValidationTab(props) {
    const {
      onChange,
      onPropertieChange,
      state,
      error,
      onCheckChange,
      handleDefaultValueChange,
      addRowDefaultValue,
      deleteDefaultValueRow,
      setObjeto,
    } = props;

    const regex = getUnitPropertie(state, "regex");
    const messageRegex = getUnitPropertie(state, "messageRegex");

    function renderchildren(node, index) {
      return (
        <StyledItem
          key={node.uuid}
          item={node}
          edit={handleDefaultValueChange}
          delete={deleteDefaultValueRow}
        />
      );
    }

    return (
      <Grid container spacing={2}>
        <Grid item size={12}>
          <TextField
            onChange={(event) => onChange(event)}
            name="value"
            variant="outlined"
            id="value"
            label={language.propertieDefaultValue}
            value={state.value || ""}
            fullWidth
            helperText={language.toolTipDefaultValue}
          />
        </Grid>
        <OnblurComponent {...props} />
        <Grid item size={12}>
          <TextField
            onChange={(event) => onPropertieChange(event)}
            name="regex"
            variant="outlined"
            id="regex"
            label={language.propertieRegex}
            value={regex || ""}
            fullWidth
            helperText={language.toolTipRegex}
          />
        </Grid>
        <Grid item size={12}>
          <TextField
            onChange={(event) => onPropertieChange(event)}
            name="messageRegex"
            variant="outlined"
            id="messageRegex"
            label={language.propertieRegexMessage}
            value={messageRegex || ""}
            error={!!getPropertieObjectById(error, "messageRegex")}
            fullWidth
            helperText={language.toolTipRegexMessage}
          />
          {error && getPropertieObjectById(error, "messageRegex") && (
            <HelperText>{language.requirederror}</HelperText>
          )}
        </Grid>

        <Grid item size={12}>
          <div>
            <h4>{language.propertieOptions}</h4>
            {findObjectDefaultValue(state, "options") &&
              findObjectDefaultValue(state, "options").map((item, index) =>
                renderchildren(item, index),
              )}
            <Button
              onClick={addRowDefaultValue}
              variant="outlined"
              startIcon={<AddIcon />}
            >
              {language.addOption}
            </Button>
          </div>
        </Grid>
      </Grid>
    );
  }

  static StylesTab(props) {
    const { onPropertieChange, state } = props;
    const propertieCSS = getUnitPropertie(state, "propertieCSS");

    return (
      <Grid container spacing={2}>
        <Grid item size={12}>
          <TextField
            onChange={(event) => onPropertieChange(event)}
            name="propertieCSS"
            variant="outlined"
            id="standard-basic"
            label={language.propertieCSS}
            value={propertieCSS || ""}
            multiline
            rows="4"
            fullWidth
            helperText={language.toolTipCSS}
          />
        </Grid>
      </Grid>
    );
  }
}
